import { Box, Grid, Typography } from "@mui/material";
import { Card, CardContent } from "../../../shared/components/ui/Card";
import { Skeleton } from "../../../shared/components/ui/skeleton";

export const DashboardSkeleton = () => {
  return (
    <>
      {/* Header com título e botão */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Skeleton variant="text" width={200} height={40} />
        <Skeleton variant="rounded" width={150} height={40} />
      </Box>

      {/* Cards de resumo */}
      <Grid container spacing={3} mb={3}>
        {[1, 2, 3, 4].map((index) => (
          <Grid item xs={12} md={3} key={index}>
            <Card>
              <CardContent>
                <Box display="flex" alignItems="center" gap={2}>
                  <Skeleton variant="circular" width={40} height={40} />
                  <Box flex={1}>
                    <Skeleton variant="text" width="60%" height={24} />
                    <Skeleton variant="text" width="40%" height={20} />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Gráficos */}
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Box sx={{ mb: 2 }}>
                <Skeleton variant="text" width="40%" height={24} />
              </Box>
              <Skeleton variant="rectangular" width="100%" height={300} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Box sx={{ mb: 2 }}>
                <Skeleton variant="text" width="40%" height={24} />
              </Box>
              <Skeleton variant="rectangular" width="100%" height={300} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Tabela de Logs de Acesso */}
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Box sx={{ mb: 2 }}>
                <Skeleton variant="text" width="30%" height={24} />
              </Box>
              <Skeleton variant="rectangular" width="100%" height={200} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Tabelas de Visitantes e Reservas */}
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Box sx={{ mb: 2 }}>
                <Skeleton variant="text" width="30%" height={24} />
              </Box>
              <Skeleton variant="rectangular" width="100%" height={200} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Box sx={{ mb: 2 }}>
                <Skeleton variant="text" width="30%" height={24} />
              </Box>
              <Skeleton variant="rectangular" width="100%" height={200} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}; 